module.exports = __webpack_public_path__ + "42b6aad0aa3faf475df0ba966fbcbb0b.svg";